import AbstractSpecification from "../specification/AbstractSpecification.js";

/**
 * `SingleAccountSpecification` is a concrete implementation
 * of `abstractSpecification` representing a server side
 * specification of a single ccount.
 *
 * @param {string} number - Account number
 */
export default class SingleAccountSpecification extends AbstractSpecification {
	constructor({ number = "" } = {}) {
		super(...arguments);
		this._number = number;
	}

	accept(visitor) {
		return visitor.visitSingleAccountSpecification(this);
	}

	getNumber() {
		return this._number;
	}

	isLeaf() {
		return true;
	}

	_serializedProperties() {
		const schema = super._serializedProperties();

		schema.number = this._number;

		return schema;
	}

	static getType() {
		return "SingleAccountSpecification";
	}
}
